
export const ISNoticiaTipo: NoticiaTipo = {
    id: "",
    nome: "",
    descricao: "",
};

export interface NoticiaTipo {
    id: string;
    nome: string;
    descricao: string;
}